import React from 'react';
import { Link } from 'react-router-dom';
import Masthead, { MastheadTitle } from '@amzn/meridian/masthead';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useAdminCapability } from '../../admin/AdminGate';
import './TopBar.css';

interface TopBarProps {
  userAlias?: string;
}

/**
 * Top bar for the chat UI. Adds an "Admin" link for members of
 * `ft-cogit-admin` (detected via the `/query` permissions probe in
 * `useAdminCapability`). The link is hidden for everyone else. Server-side
 * enforcement still applies — the link being visible is not itself a grant.
 */
const TopBar: React.FC<TopBarProps> = ({ userAlias }) => {
  const headerBackgroundColor = '#0F172A';
  const hasAdmin = useAdminCapability();

  return (
    <Masthead backgroundColor={headerBackgroundColor} size="large">
      <MastheadTitle>
        <Row alignmentVertical="center">
          <img
            src="/ordis-logo.png"
            alt="Ordis logo"
            className="app-logo"
            width={40}
            height={40}
          />
          <h1 className="app-title">GFT Ordis</h1>
        </Row>
      </MastheadTitle>
      <Row alignmentVertical="center" spacing="medium">
        {hasAdmin && (
          <Link
            to="/admin"
            style={{
              color: '#FFFFFF',
              textDecoration: 'none',
              fontSize: '14px',
              padding: '0.25rem 0.75rem',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '4px',
            }}
          >
            Admin
          </Link>
        )}
        {userAlias && (
          <Text type="b300" className="user-alias-text">
            Greetings, {userAlias}
          </Text>
        )}
      </Row>
    </Masthead>
  );
};

export default TopBar;
